/* MDB: Google badge ↔ Live chat, lifted above sticky ATC when visible */
(function () {
  if (window.__mdbGBadgeAlign) return;
  window.__mdbGBadgeAlign = true;

  var BASE = 80;

  function chatNode() {
    var host = document.querySelector('shopify-chat');
    if (host) {
      try {
        if (host.shadowRoot) {
          var inner =
            host.shadowRoot.querySelector('[part="button"], button, [role="button"], a') ||
            host.shadowRoot.querySelector('[class*="activator"], [class*="launcher"], [class*="button"]');
          if (inner) return inner;
        }
      } catch (e) {}
      return host;
    }
    return document.querySelector('#shopify-chat, [id*="ShopifyChat"]');
  }

  function stickyClear() {
    var bar = document.querySelector('.mdb-pdp-sticky-atc.is-visible');
    if (!bar || window.matchMedia('(min-width: 990px)').matches) return 0;
    var h = Math.ceil(bar.getBoundingClientRect().height);
    return h > 0 ? h + 8 : 0;
  }

  function ensureSoftStyle() {
    if (document.getElementById('mdb-g-badge-align')) return;
    var style = document.createElement('style');
    style.id = 'mdb-g-badge-align';
    style.textContent =
      '.mdb-g-badge{background:rgba(255,255,255,.92)!important;-webkit-backdrop-filter:saturate(1.2) blur(10px);backdrop-filter:saturate(1.2) blur(10px);border:1px solid rgba(0,0,0,.08);box-shadow:0 1px 6px rgba(0,0,0,.1)!important;}' +
      'body.mdb-pdp-sticky-pad{--shopify-chat-activator-offset:calc(var(--mdb-pdp-chat-base-offset,80px) + var(--mdb-pdp-sticky-clear,5.75rem))!important;}';
    (document.head || document.documentElement).appendChild(style);
  }

  function align() {
    ensureSoftStyle();
    var clear = stickyClear();
    document.documentElement.style.setProperty('--mdb-pdp-chat-base-offset', BASE + 'px');
    document.documentElement.style.setProperty('--mdb-pdp-sticky-clear', clear + 'px');

    var bottom = BASE + clear;
    var chat = chatNode();
    if (chat) {
      var rect = chat.getBoundingClientRect();
      if (rect.width >= 4 && rect.height >= 4 && rect.bottom > 0) {
        var fromChat = Math.max(0, Math.round(window.innerHeight - rect.bottom));
        /* When sticky ATC is up, never sit lower than clear+base */
        bottom = Math.max(fromChat, BASE + clear);
      }
    }

    document.documentElement.style.setProperty('--shopify-chat-activator-offset', bottom + 'px');

    var badge = document.querySelector('[data-mdb-g-badge], .mdb-g-badge');
    if (badge) badge.style.setProperty('bottom', bottom + 'px', 'important');
  }

  var scheduled = false;
  function schedule() {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(function () {
      scheduled = false;
      align();
    });
  }

  function boot() {
    align();
    var tries = 0;
    var tick = setInterval(function () {
      align();
      tries += 1;
      if (tries > 48) clearInterval(tick);
    }, 250);
    window.addEventListener('resize', schedule, { passive: true });
    window.addEventListener('scroll', schedule, { passive: true });
    if (typeof MutationObserver !== 'undefined') {
      new MutationObserver(schedule).observe(document.documentElement, {
        attributes: true,
        childList: true,
        subtree: true,
        attributeFilter: ['class', 'style', 'aria-hidden'],
      });
    }
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
